module.exports = __webpack_public_path__ + "img/tether.9250821f.png";